/** @jsxImportSource @emotion/react */
import { SerializedStyles } from '@emotion/react';
import { useState } from 'react';

import { CLOSE_OUT_SCAN_TYPE_LABEL, useScopeSubmissionAction } from '@/Client/State/useScopeSubmissionAction';
import { ConfirmActionDialog } from '@/Client/Widgets/ConfirmActionDialog';
import { MAIN_NAVIGATION_BUTTON_STYLES } from './mainNavigationStyles';

export const BUTTON_TEST = (scope: string) => `Submit ${scope}`;
export const CONFIRM_ACTION_MESSAGE = (scope: string) => `Are you ready to submit this ${scope} for review?`;
export const CONFIRM_ACTION_LABEL = (scope: string) => `Yes, Submit ${scope}`;
export const CLOSEOUT_PREVIEW_TOOLTIP = 'All tasks need to be marked as Complete in order to submit Closeout.';

export const SubmitScopeHeaderAction = ({ buttonStyle = MAIN_NAVIGATION_BUTTON_STYLES.primary }: { buttonStyle?: SerializedStyles }) => {
  const { canSubmit, scanTypeLabel, showDisabledCloseoutPreview, submitForReview, turnBasedHandoffReplacesSubmission } = useScopeSubmissionAction();
  const [modalOpen, setModalOpen] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  if (turnBasedHandoffReplacesSubmission) return null;

  if (showDisabledCloseoutPreview) {
    return (
      <button type={'button'} css={buttonStyle} disabled={true} title={CLOSEOUT_PREVIEW_TOOLTIP}>
        {BUTTON_TEST(CLOSE_OUT_SCAN_TYPE_LABEL)}
      </button>
    );
  }

  if (!canSubmit || !scanTypeLabel) return null;

  const confirmSubmit = async () => {
    setSubmitting(true);
    try {
      await submitForReview();
      setModalOpen(false);
    } finally {
      setSubmitting(false);
    }
  };
  const buttonText = BUTTON_TEST(scanTypeLabel);

  return (
    <>
      <button type={'button'} css={buttonStyle} onClick={() => setModalOpen(true)}>
        {buttonText}
      </button>
      {modalOpen
        ? (
          <ConfirmActionDialog
            title={buttonText}
            message={CONFIRM_ACTION_MESSAGE(scanTypeLabel)}
            confirmLabel={CONFIRM_ACTION_LABEL(scanTypeLabel)}
            busy={submitting}
            onConfirm={confirmSubmit}
            onCancel={() => setModalOpen(false)}
          />
        )
        : null}
    </>
  );
};
